module.exports = __webpack_public_path__ + "img/parking_meter.579384a5.jpg";